import { useTranslation } from '../../lib/i18n'

export default function MembershipInvitationNotification({ notification }) {
  const { t } = useTranslation()
  return (
    <>
      <p className="w-full max-w-200 md:max-w-300 line-clamp-2 overflow-hidden">
        {t('notifications.membershipInvitation')}{' '}
        <span className="text-off-black font-bold">
          {notification.notifiable?.group_name}
        </span>
      </p>
    </>
  )
}
